export const NAVIGATION_LAYOUT = {
  AUTO: 'auto',
  LEFT: 'left',
  LEFT_COMPACT: 'left-compact',
  TOP: 'top',
};

export const NAVIGATION_LAYOUT_STORAGE_KEY = 'baochau.portal.navigation.layout';

const VALID_NAVIGATION_LAYOUTS = new Set(Object.values(NAVIGATION_LAYOUT));

export const normalizeNavigationLayout = (value) => {
  const normalizedValue = `${value || ''}`.trim().toLowerCase();
  return VALID_NAVIGATION_LAYOUTS.has(normalizedValue) ? normalizedValue : NAVIGATION_LAYOUT.AUTO;
};

export const getStoredNavigationLayout = () => {
  if (typeof window === 'undefined') {
    return NAVIGATION_LAYOUT.AUTO;
  }

  try {
    return normalizeNavigationLayout(window.localStorage.getItem(NAVIGATION_LAYOUT_STORAGE_KEY));
  } catch (error) {
    return NAVIGATION_LAYOUT.AUTO;
  }
};

export const persistNavigationLayout = (value) => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(NAVIGATION_LAYOUT_STORAGE_KEY, normalizeNavigationLayout(value));
  } catch (error) {}
};

export const resolveNavigationLayout = ({ preference, viewportWidth, isMobileViewport }) => {
  if (isMobileViewport) {
    return NAVIGATION_LAYOUT.LEFT;
  }

  const normalizedPreference = normalizeNavigationLayout(preference);
  const safeViewportWidth = Number(viewportWidth) || 1440;

  switch (normalizedPreference) {
    case NAVIGATION_LAYOUT.LEFT:
      return safeViewportWidth < 1200 ? NAVIGATION_LAYOUT.LEFT_COMPACT : NAVIGATION_LAYOUT.LEFT;
    case NAVIGATION_LAYOUT.LEFT_COMPACT:
      return NAVIGATION_LAYOUT.LEFT_COMPACT;
    case NAVIGATION_LAYOUT.TOP:
      return safeViewportWidth < 1280 ? NAVIGATION_LAYOUT.LEFT_COMPACT : NAVIGATION_LAYOUT.TOP;
    case NAVIGATION_LAYOUT.AUTO:
    default:
      if (safeViewportWidth >= 1280) {
        return NAVIGATION_LAYOUT.TOP;
      }

      if (safeViewportWidth >= 992) {
        return NAVIGATION_LAYOUT.LEFT_COMPACT;
      }

      return NAVIGATION_LAYOUT.LEFT;
  }
};

export const NAVIGATION_LAYOUT_OPTIONS = [
  {
    value: NAVIGATION_LAYOUT.AUTO,
    label: 'Tự động',
    description: 'Màn desktop dùng menu trên, màn vừa tự thu gọn để ưu tiên diện tích form.',
  },
  {
    value: NAVIGATION_LAYOUT.LEFT,
    label: 'Menu trái',
    description: 'Giữ menu dọc đầy đủ để rà nhanh nhóm chức năng.',
  },
  {
    value: NAVIGATION_LAYOUT.LEFT_COMPACT,
    label: 'Trái thu gọn',
    description: 'Giữ menu dọc nhưng giảm bề ngang cho form nghiệp vụ.',
  },
  {
    value: NAVIGATION_LAYOUT.TOP,
    label: 'Menu trên',
    description: 'Đưa điều hướng lên trên để nhường toàn bộ chiều ngang.',
  },
];

export const getNavigationLayoutLabel = (value) =>
  NAVIGATION_LAYOUT_OPTIONS.find((item) => item.value === normalizeNavigationLayout(value))?.label || 'Tự động';
